import { motion } from "framer-motion";
import { MaskedLines, Eyebrow } from "@/components/site/Motion";

export default function PageHead({ eyebrow, titleLines, lede, image, chapter }) {
  return (
    <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28 border-b border-line overflow-hidden">
      {image && (
        <>
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${image})` }} />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/90 via-ink/80 to-ink" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-4 mb-6">
          {chapter && <span className="font-mono text-xs text-mist">{chapter}</span>}
          <span className="h-px w-10 bg-signal" />
          <Eyebrow>{eyebrow}</Eyebrow>
        </div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white leading-[1.04] max-w-4xl">
          <MaskedLines lines={titleLines} startDelay={0.1} />
        </h1>
        {lede && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.7 }}
            className="mt-8 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl"
          >
            {lede}
          </motion.p>
        )}
      </div>
    </section>
  );
}
